<template>
  <section class="userAccountMsg">
    <p>
      尊敬的 <span class="name">{{ name }}</span
      >，欢迎登录使用。<span class="loginOut" @click="loginOut">退出登录</span>
    </p>
  </section>
</template>

<script>
// import { mapActions } from "vuex";
export default {
  data() {
    return {
      name: ""
    };
  },
  created() {
    this.$common
      .http({
        url: "/api/pcenter/detail"
      })
      .then(res => {
        this.name = res.data.data.name;
      });
  },
  methods: {
    loginOut() {
      // token 值
      let projectNameArray = window.location.pathname.split("/");
      let projectName = (projectNameArray[1] || "") + "token";
      window.localStorage.removeItem(projectName);
      // 同浏览器的不同tab同时刷新
      window.localStorage.setItem("changeFactory", new Date().getTime());
      this.$router.push("/rhqy/login");
      // this.$common
      //   .http({
      //     url: "/api/authorize/logout",
      //     data: {}
      //   })
      //   .then(() => {
      //     this.$router.push("/rhqy/login");
      //     // 同浏览器的不同tab同时刷新
      //     window.localStorage.setItem("changeFactory", new Date().getTime());
      //   });
    }
  }
};
</script>
<style scoped lang="less">
.userAccountMsg {
  padding: 0px 20px;
}
.name {
  color: #b08931;
}
.loginOut {
  color: #1890ff;
  cursor: pointer;
  text-decoration: underline;
}
</style>
